import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "circle-error",
  "use": "circle-error-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle-error\"><path d=\"M11 1.486c-5.246 0-9.514 4.268-9.514 9.514 0 5.246 4.268 9.514 9.514 9.514 5.246 0 9.514-4.268 9.514-9.514 0-5.246-4.268-9.514-9.514-9.514M11 22C4.935 22 0 17.065 0 11S4.935 0 11 0c6.066 0 11 4.935 11 11s-4.934 11-11 11\" /><path d=\"M9.625 12.99V4.74h2.75v8.25h-2.75zm0 4.278v-2.75h2.75v2.75h-2.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/circle-error.svg
// module id = 1545
// module chunks = 0